import { Component } from '@angular/core';
import { CesionarioSummaries, Clientes, DashboardFilterViewModel, Proveedor, DateFilters } from '../../../factoring/interface/data.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CompaniesService } from '../../../factoring/services/companies.service';
import { delay, finalize } from 'rxjs';

@Component({
  selector: 'app-companys-un-executive',
  templateUrl: './companys-un-executive.component.html',
  styleUrls: ['./companys-un-executive.component.scss']
})
export class CompanysUnExecutiveComponent {
  public sendDateFilter: DateFilters;
  public proveedorCompany: Proveedor;
  public clientes: PageResult<Clientes>;
  public cesionarioSummaries: CesionarioSummaries;
  public panelOpenState = false;
  public providerSummaries: PageResult<Proveedor>;
  public booleanFlag: boolean = false;
  public booleanFlagCesionario: boolean = false;
  public booleanText: boolean = false;
  public dashboardFilter: DashboardFilterViewModel;

  constructor( private company: CompaniesService ) {
    this.providerSummaries = {
      ...this.providerSummaries,
      results: [],
    };
    this.clientes = {
      ...this.clientes,
      results: [],
    };

    //Hace la cuenta desde hoy hace 3 meses atras
    const currentDate = new Date();
    const ultimoDia = new Date(currentDate).toISOString();
    const primerDia = new Date('1900-01-01').toISOString();

    this.dashboardFilter = {
      ...this.dashboardFilter,
      startDate: primerDia,
      endDate: ultimoDia,
      page: 1,
      size: 10,
      search: '',
      sii: true,
      isPyme: false,
      sortOrder: ''
    };
  }

  ngOnInit(): void {
    this.getAllCompanies();
  }

  /**
   * Metodo para recibir evento de cambio de filtro de fecha de inicio y termino de consulta de empresas proveedores y cesionarias
   * @param event Nuevas fechas de inicio y termino seleccionadas en filtro
   */
  receiveFilterDate(event: DateFilters) {
    const { dateStart, dateEnd } = event;
    this.dashboardFilter = {
      ...this.dashboardFilter,
      startDate: dateStart,
      endDate: dateEnd,
    };
    this.getAllCompanies();
  }

  receiveChangeSortingOrder(sortOrder: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sortOrder: sortOrder
    }
    this.getAllCompanies();
  }

  //Filtro por Nombre
  async receiveFilterCompany(event: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      search: event,
    };
    this.getAllCompanies();
  }

  /**
   * Metodo para recibir evento de cambio de paginacion de tabla de proveedores (tamanio y pagina seleccionada)
   * @param changePagination Parametros de paginacion seleccionadas en tabla de proveedores (page: Pagina, Size: N° de registro de pagina)
   *
   */
  public receiveProviderPaginationChange(changePagination: any) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      page: changePagination.page,
      size: changePagination.size,
    };
    this.getAllCompanies();
  }
  public receiveChangePymeFilter(event: boolean | null) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      isPyme: event,
    };
    if (this.dashboardFilter.isPyme == null) {
      this.dashboardFilter = {
        ...this.dashboardFilter,
        isPyme: event,
      };
    }
    this.getAllCompanies();

  }
  /**
   * Metodo para recibir cambio en filtro de enrolamiento de clave SII
   * @param event Nuevo valor seleccionado en filtro
   */
  public receiveChangeSiiFilter(event: boolean | null) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sii: event,
    };
    this.getAllCompanies();
  }

  public getAllCompanies() {
    const { startDate, endDate, search, page, size, sii, isPyme, sortOrder } =
    this.dashboardFilter;
    this.booleanFlag = true;
    this.booleanText = true;
    this.company
      .getCompaniesSinAsingnar(startDate, endDate, page, search, size, sii, isPyme, sortOrder)
      .pipe(
        delay(1500),
        finalize(() => { this.booleanFlag = false }),
      )
      .subscribe({
        next: (response) => {
          if (response.results.length == 0) {
            this.booleanText = false
          }
          this.clientes = response;
          this.booleanFlag = false
        },
        error: (e) => {
          //que ocurre cuando hay un error
          console.log(e)
        },
        complete: () => {
          this.booleanFlag = true
        }
      });
  }
  
}
